module.exports = __webpack_public_path__ + "img/banner4.2cf7b6cf.png";